import React from "react";
import { Row, Col, Container, Button, Card } from "react-bootstrap";
import portfolio from "./portfolioList";
import gdPortfolioList from "./gdportfoliolist";

const Portfolio = ({ webDev }) => {
  return (
    <section
      id="portfolio"
      className={
        webDev ? "home_portfolio bg-white my-5 position-relative" : "gd_portfolio bg-white my-5 position-relative"
      }
    >
      <Container>
        {webDev
          ? portfolio.map((item) => {
              const { title, description, image, tools, github, demo } = item;

              return (
                <Row
                  className="mb-4"
                  key={title}
                >
                  <Card className="flex-lg-row py-3 ">
                    <div className="me-3 img-container ">
                      <Card.Img
                        fluid="true"
                        src={image}
                      />
                    </div>

                    <Card.Body>
                      <Card.Title>
                        <h5 className="fw-semibold">{title}</h5>
                      </Card.Title>

                      {/* ********************************************TOOLS */}
                      <div className="d-flex flex-row mb-4 flex-wrap">
                        {tools.map((tool) => {
                          return (
                            <p
                              key={tool}
                              style={{
                                backgroundColor: "transparent ",
                                margin: "0 10px 5px 0",
                                padding: "3px 20px",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                fontSize: ".7rem",
                                border: "solid lightgrey 2px",
                                borderRadius: "50px",
                                color: "grey",
                              }}
                            >
                              {tool}
                            </p>
                          );
                        })}
                      </div>

                      <Card.Text>{description}</Card.Text>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          href={github}
                          target="_blank"
                        >
                          Code
                        </Button>
                        <Button
                          variant="primary"
                          href={demo}
                          target="_blank"
                        >
                          Live Demo
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Row>
              );
            })
          : gdPortfolioList.map((item) => {
              const { title, description, image, tools, github, demo } = item;

              return (
                <Col
                  lg="4"
                  className="mb-4 gd-card-row"
                  key={title}
                >
                  <Card className=" position-relative ">
                    <div className="me-3 img-container ">
                      <Card.Img
                        fluid="true"
                        src={image}
                      />
                    </div>

                    <Card.Body className="gd-overlay">
                      <Card.Title>
                        <h5 className="fw-semibold">{title}</h5>
                      </Card.Title>

                      {/* ********************************************TOOLS */}
                      <div className="d-flex flex-row mb-4 flex-wrap">
                        {tools.map((tool) => {
                          return (
                            <p
                              key={tool}
                              style={{
                                backgroundColor: "transparent ",
                                margin: "0 10px 5px 0",
                                padding: "3px 20px",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                fontSize: ".7rem",
                                border: "solid lightgrey 2px",
                                borderRadius: "50px",
                                color: "grey",
                              }}
                            >
                              {tool}
                            </p>
                          );
                        })}
                      </div>

                      <Card.Text>{description}</Card.Text>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          href={github}
                          target="_blank"
                        >
                          Code
                        </Button>
                        <Button
                          variant="primary"
                          href={demo}
                          target="_blank"
                        >
                          Live Demo
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
      </Container>
    </section>
  );
};

export default Portfolio;
